export default __webpack_public_path__ + "static/media/Baj.585009e4.png";